<template>
	<span>{{ value }}</span>
</template>

<script>

export default {

	props: [ 'row', 'field' ],

	data() {
		return {
			decimals: 2,
			type: '',
		};
	},

	mounted() {
		if (this.field.specific_data.indexOf(',') !== -1) {
			const [ decimals, type ] = this.field.specific_data.split(',');
			this.decimals = decimals;
			this.type = type;
		}
	},

	computed: {

		value() {
			const value = this.row[ this.field.slug ];

			if (!value || (value || '').length === 0) {
				return '';
			}

			switch (this.type) {
				case 'percent':
					return value + '%';
				case 'currency':
					return new Intl.NumberFormat('en-US', {
						style: 'currency',
						currency: 'USD',
						maximumFractionDigits: this.decimals,
						minimumFractionDigits: this.decimals
					}).format(value);
				default:
					return value;
			}
		}
	}
};

</script>
